module.exports = {};


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/core-js/library/modules/_iterators.js
// module id = 95
// module chunks = 0